<template>
    <div class="diagnosis">
        <div class="wx_box">
            <div class="wx_main">
                <div class="top">
                    <div class="wx_title">
                        <span>智能诊断</span>
                    </div>
                </div>
                <div class="select_year">
                    <span class="label">选择年份:</span>
                    <el-date-picker v-model="year" type="year" format="yyyy" size="mini" value-format="yyyy"
                                    :picker-options="pickerOptions" placeholder="选择年" @change="changeYear">
                    </el-date-picker>
                    <div class="diagnosis_btns" v-if="user_position_code==150">
                        <el-button @click="artificialShow = true">人工诊断</el-button>
                    </div>
                </div>
                <div class="tabs">
					<span :class="{'active':tabShowNum==item.id}" @click="clickArea(item.id)"
                          v-for="(item,index) in area_list" :key="index">{{item.name}}</span>

                </div>
                <table class="my_table">
                    <thead>
                    <tr>
                        <th>任务名</th>
                        <th>时间</th>
                        <th>诊断结果</th>
                        <th>解决方案</th>
                        <th>后续任务</th>
                        <th width="234">操作</th>
                    </tr>
                    </thead>
                    <tbody>
                  
                    <tr v-for="(item,index) in diagnose_list" :key="index">
                        <td>{{item.worktask.task_name}}</td>
                        <td>{{item.display_time}}</td>
                        <td>{{item.rule.result}}</td>
                        <td>{{item.case.name}}</td>
                        <td><span v-for="(val,inx) in item.task_list">{{val.task_name}}<br></span></td>
                        <td>
                            <el-button class="edit_btn" type="primary" plain size="small" @click="diagnosisShow = true,diagnose_id=item.id" v-if="item.is_result==2 && user_position_code==150">诊断</el-button>
                               <span v-else>-</span>
						</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!--人工诊断-->
        <WxMessageBox :show="artificialShow" @save="artificialSave" @canse="artificialCanse">
            <div slot="content">
				
                <el-form :model="artificialForm"  :rules="artificialRules" ref="artificialForm" label-width="0px">
                    <div class="wx_form">
                        <div class="form_item">
                            <span class="label">来自任务(*):</span>
                            <div class="input">
                                <el-form-item label="" prop="task_id">
                                    <el-select v-model="artificialForm.task_id" placeholder="请选择" size="mini">
                                        <el-option
                                                v-for="item in task_list"
                                                :key="item.id"
                                                :label="item.task_name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form_item">
                            <span class="label">选择诊断项目(*):</span>
                            <div class="input">
                                <el-form-item label="" prop="diagnose_id">
                                    <el-select v-model="artificialForm.diagnose_id" placeholder="请选择" size="mini" @change="changeProject">
                                        <el-option
                                                v-for="item in project_list"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form_item">
                            <span class="label">选择诊断结果(*):</span>
                            <div class="input">
                                <el-form-item label="" prop="rule_id">
                                    <el-select v-model="artificialForm.rule_id" placeholder="请选择" size="mini">
                                        <el-option
                                                v-for="item in results_list"
                                                :key="item.id"
                                                :label="item.result"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
        </WxMessageBox>
        <!--诊断-->
        <WxMessageBox :show="diagnosisShow" @save="diagnosisSave" @canse="diagnosisCanse">
            <div slot="content">
                <el-form :model="diagnosisForm"  :rules="diagnosisRules" ref="diagnosisForm" label-width="0px">
                    <div class="wx_form">
                        <div class="form_item">
                            <span class="label">选择诊断项目</span>
                            <div class="input">
                                <el-form-item label="" prop="diagnose_id">
                                    <el-select v-model="diagnosisForm.diagnose_id" placeholder="请选择" size="mini"  @change="changeProject">
                                        <el-option
                                                v-for="item in project_list"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form_item">
                            <span class="label">选择诊断结果</span>
                            <div class="input">
                                <el-form-item label="" prop="rule_id">
                                    <el-select v-model="diagnosisForm.rule_id" placeholder="请选择" size="mini" >
                                        <el-option
                                                v-for="item in results_list"
                                                :key="item.id"
                                                :label="item.result"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
        </WxMessageBox>
    </div>
</template>

<script>
	import {
		getFarmDiagnoseList,
		createFarmDiagnose,
		saveFarmDiagnose,
		getDiagnoseRuleList
	} from '@/api/diagnose'
	import {
		getFarmInfo,
		getFarmAreaList
	} from '@/api/api.js'
    import WxMessageBox from '@/components/MessageBox';
    export default {
        name: "Diagnose",
        data(){
            return{
                year: new Date().getFullYear().toString(),
				year_list:[],
				pickerOptions: this.disabledDate(),
                tabShowNum: 0,
                weatherShowNum: 0,
                area_list: [],
                diagnosisShow:false,
				diagnose_id:0,
                diagnosisForm:{
                    project:'',
                    results:''
                },
				diagnosisRules:{
					rule_id: [{
							required: true,
							message: '请选择诊断结果',
							trigger: 'change'
						}
					],
					diagnose_id: [{
							required: true,
							message: '请选择诊断项目',
							trigger: 'change'
						}
					],
				    
				},
				diagnose_list:[],
				user_position_code:'',
                task_list:[],
                project_list:[],
                results_list:[],
                artificialShow:false,
                artificialForm:{
                    task_id:'',
                    rule_id:'',
                    diagnose_id:''
                },
				artificialRules:{
				    task_id: [{
				    		required: true,
				    		message: '请选择任务',
				    		trigger: 'change'
				    	}
				    ],
					rule_id: [{
							required: true,
							message: '请选择诊断结果',
							trigger: 'change'
						}
					],
					diagnose_id: [{
							required: true,
							message: '请选择诊断项目',
							trigger: 'change'
						}
					],
				    
				},
				
				
            }
        },
		created() {
		
			getFarmInfo(this.$route.params.id).then(resp => {
			
			
				if(resp.farm.is_check==1){
					this.get_farm_area()
				}else{
					this.$message.error("请先完善农事管理板块相关申请工作，才能开通此板块！")
					this.$router.push("/park/detail/"+this.$route.params.id)
				}
				})
		},
        methods:{
			changeProject(val){
				
				getDiagnoseRuleList(val,this.tabShowNum).then(resp=>{
					this.results_list=resp
				})
			},
			get_farm_area(){
				let that=this
				getFarmAreaList(this.$route.params.id,this.year).then(resp=>{
					  this.area_list=resp.area_list
					   this.year_list=resp.year_list
					   this.task_list=resp.task_list
					   this.project_list=resp.project_list
					   resp.area_list.forEach((item,index)=>{
						    if(index==0){
								this.tabShowNum=item.id
								console.log(item.year)
								that.get_diagnose_list(item.farm_id,item.id,item.year)
							}
					   })
				})
			},
			get_diagnose_list(farm_id,area_id,year){
				
				 getFarmDiagnoseList(farm_id,area_id,year).then(resp=>{
					 this.diagnose_list=resp.diagnose_list
					 this.user_position_code=resp.user_position_code
				})
			},
			disabledDate() {
				let that = this
				
				return {
					disabledDate(date) {
						let result=true
						if(that.year_list.includes(date.getFullYear()))
						{
					    result=false
						}else{
						
						}
						return result						
					}
				}
			},
            changeYear(val){
				this.year=val
				this.get_farm_area()
			},
            clickArea(id) {
                this.tabShowNum = id
				this.get_diagnose_list(this.$route.params.id,id,this.year)
            },
            artificialSave(){
				console.log(this.artificialForm)
				this.$refs["artificialForm"].validate((valid) => {
				//	console.log(valid)
					if (valid) {
						this.artificialShow = false
					 	 createFarmDiagnose(this.artificialForm).then(resp=>{
							 this.$message.success("成功")
							this.get_farm_area()
							
							}).catch(error=>console.log(error))
							
					} else {
						console.log('error submit!!');
						return false;
					}
				});
                
            },
            artificialCanse(){
                this.artificialShow = false
            },
            diagnosisSave(){
				
				console.log("aaaaaaaaaaa")
				this.$refs["diagnosisForm"].validate((valid) => {
				//	console.log(valid)
					if (valid) {
						this.diagnosisShow = false
					 	 saveFarmDiagnose(this.diagnose_id,this.diagnosisForm).then(resp=>{
							  this.$message.success("成功")
							this.get_farm_area()
							
							}).catch(error=>console.log(error))
							
					} else {
						console.log('error submit!!');
						return false;
					}
				});
                
            },
            diagnosisCanse(){
                this.diagnosisShow = false
            },
        },
        components: {
            WxMessageBox
        }
    }
</script>

<style lang="less">
    .diagnosis {
        .wx_box {
            .wx_main {
                padding: 17px 17px 80px 18px;
                background: radial-gradient(rgba(19, 62, 173, 0.74), rgba(5, 18, 32, 0.47));

                .top {
                    width: 100%;
                    overflow: hidden;
                }

                .select_year {
                    margin-top: 25px;
                    display: flex;
                    align-items: center;

                    .label {
                        width: 80px;
                        font-size: 16px;
                        color: #91AFBA;
                    }

                    .el-date-editor {
                        width: 180px;
                    }

                    .el-input__inner {
                        width: 180px;
                        text-align: center;
                        font-size: 16px;
                    }

                    .climate_btn {
                        width: 150px;
                        height: 30px;
                        line-height: 30px;
                        padding: 0;
                        margin-left: 120px;
                    }
                }
                .tabs {
                    display: flex;
                    margin: 20px 0 30px 0;

                    span {
                        width: 150px;
                        height: 22px;
                        border: 1px solid #2B92F6;
                        line-height: 22px;
                        font-size: 14px;
                        color: #fff;
                        text-align: center;
                        cursor: pointer;
                    }

                    .active {
                        background: #2B92F6;
                        color: #fff;
                    }
                }
                .diagnosis_btns{
                    margin-left: auto;
                    .el-button{
                        width: 150px;
                        height: 40px;
                        line-height: 40px;
                        border: 1px solid #2D99FF;
                        background-color: transparent;
                        font-size: 18px;
                        font-weight: 400;
                        color: #2D99FF;
                        padding: 0;
                        border-radius: 0;
                    }
                }
            }
        }

    }
</style>